export default "__VITE_ASSET__CtmTTzkh__"